import React from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const Testimonials = () => {
  const testimonialImages = [
    
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-37-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-38-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-5-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-2-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-13-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-6-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-7-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-8-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-9-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-10-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-11-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-12-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-14-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-16-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-17-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-18-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-19-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-20-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-21-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-22-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-23-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-24-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-25-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-26-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-27-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-28-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-29-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-30-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-31-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-32-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-33-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-34-1024x1024.png',
    'https://linkinprofessionals.com/images/Blue-and-White-Digitalism-Testimonial-Instagram-Post-35-1024x1024.png'
  ];

  return (
    <section id="testimonials" className="relative py-24 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 overflow-hidden" data-testid="testimonials-section">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full text-sm font-semibold shadow-lg">
              Success Stories
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Student{' '}
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              Testimonials
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
            Hear from our successful students who have transformed their careers and achieved their dreams
          </p>
          
          {/* Stats bar */}
          <div className="flex items-center justify-center gap-8 mt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-1">500+</div>
              <div className="text-sm text-gray-600">Success Stories</div>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-500 text-lg" />
                ))}
              </div>
              <div className="text-sm text-gray-600">5.0 Average Rating</div>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 mb-1">95%</div>
              <div className="text-sm text-gray-600">Satisfaction Rate</div>
            </div>
          </div>
        </div>

        {/* Carousel */}
        <div className="relative">
          <Carousel
            opts={{
              align: 'start',
              loop: true,
            }}
            plugins={[
              Autoplay({
                delay: 4000,
              }),
            ]}
            className="w-full"
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {testimonialImages.map((image, index) => (
                <CarouselItem key={index} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="p-2">
                    {/* Testimonial Card */}
                    <div className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 border-2 border-gray-100">
                      {/* Decorative top accent */}
                      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600"></div>
                      
                      {/* Quote icon */}
                      <div className="absolute top-4 left-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-3 rounded-full shadow-lg z-10">
                        <FaQuoteLeft className="text-lg" />
                      </div>

                      {/* Image container with better visibility */}
                      <div className="relative bg-gradient-to-br from-gray-50 to-white p-4">
                        <div className="relative rounded-xl overflow-hidden shadow-lg">
                          <img
                            src={image}
                            alt={`Student Success Story ${index + 1}`}
                            className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
                            loading="lazy"
                            data-testid={`testimonial-image-${index}`}
                          />
                          {/* Subtle overlay for better image contrast */}
                          <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent group-hover:from-black/10 transition-all duration-300"></div>
                        </div>
                      </div>

                      {/* Bottom accent */}
                      <div className="p-4 bg-gradient-to-br from-blue-50 to-purple-50">
                        <div className="flex items-center justify-between">
                          <div className="flex gap-1">
                            {[...Array(5)].map((_, i) => (
                              <FaStar key={i} className="text-yellow-500 text-sm" />
                            ))}
                          </div>
                          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                            Verified Review
                          </span>
                        </div>
                      </div>

                      {/* Decorative corner */}
                      <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-tl from-purple-100/50 to-transparent rounded-tl-full"></div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            
            {/* Enhanced Navigation Buttons */}
            <CarouselPrevious 
              className="hidden md:flex -left-12 w-14 h-14 border-2 border-blue-600 bg-white text-blue-600 hover:bg-blue-600 hover:text-white shadow-xl transition-all" 
              data-testid="testimonial-prev" 
            />
            <CarouselNext 
              className="hidden md:flex -right-12 w-14 h-14 border-2 border-blue-600 bg-white text-blue-600 hover:bg-blue-600 hover:text-white shadow-xl transition-all" 
              data-testid="testimonial-next" 
            />
          </Carousel>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-4 text-lg">Want to be our next success story?</p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all"
          >
            Start Your Journey
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;